class FlooringCalculator {
  constructor(root) {
    this.root = root;
    this.config = this.getConfig();
    this.elements = this.getElements();
    this.init();
  }

  getConfig() {
    const config = this.root.querySelector('[data-fc-config]');
    return {
      packCoverage: parseFloat(config.dataset.packCoverage) || 1.872,
      wastagePercent: parseFloat(config.dataset.wastagePercentage) || 10,
      packPrice: parseFloat(config.dataset.packPrice) || 0,
      pricePerSqm: parseFloat(config.dataset.pricePerSqm) || 0,
      currency: config.dataset.currency || 'GBP'
    };
  }

  getElements() {
    return {
      areaInput: this.root.querySelector('[data-fc-area]'),
      wastageToggle: this.root.querySelector('[data-fc-wastage-toggle]'),
      wastageInfo: this.root.querySelector('[data-fc-wastage-info]'),
      totalPrice: this.root.querySelector('[data-fc-total-price]'),
      packsDisplay: this.root.querySelector('[data-fc-packs]'),
      totalArea: this.root.querySelector('[data-fc-total-area]'),
      qtyInput: this.root.querySelector('[data-fc-qty-input]'),
      qtyMinus: this.root.querySelector('[data-fc-qty-minus]'),
      qtyPlus: this.root.querySelector('[data-fc-qty-plus]')
    };
  }

  init() {
    this.elements.areaInput.addEventListener('input', () => this.calculate());

    if (this.elements.wastageToggle) {
      this.elements.wastageToggle.addEventListener('change', (e) => {
        if (this.elements.wastageInfo) {
          this.elements.wastageInfo.style.display = e.target.checked ? 'block' : 'none';
        }
        this.calculate();
      });
    }

    if (this.elements.qtyMinus) {
      this.elements.qtyMinus.addEventListener('click', () => this.decreaseQty());
    }

    if (this.elements.qtyPlus) {
      this.elements.qtyPlus.addEventListener('click', () => this.increaseQty());
    }

    if (this.elements.qtyInput) {
      this.elements.qtyInput.addEventListener('change', () => this.updateFromQtyInput());
    }

    this.calculate();
  }

  calculate() {
    const area = parseFloat(this.elements.areaInput.value) || 0;
    const includeWaste = this.elements.wastageToggle ? this.elements.wastageToggle.checked : false;

    const wastageMultiplier = includeWaste ? 1 + (this.config.wastagePercent / 100) : 1;
    const totalArea = area * wastageMultiplier;
    const packs = Math.ceil(totalArea / this.config.packCoverage);
    const totalPrice = packs * this.config.packPrice;

    if (this.elements.totalPrice) {
      this.elements.totalPrice.textContent = this.formatMoney(totalPrice);
    }

    if (this.elements.packsDisplay) {
      this.elements.packsDisplay.textContent = packs;
    }

    if (this.elements.totalArea) {
      this.elements.totalArea.innerHTML = `${totalArea.toFixed(2)} m<sup>2</sup>`;
    }

    if (this.elements.qtyInput) {
      this.elements.qtyInput.value = packs;
    }
  }

  decreaseQty() {
    const current = parseInt(this.elements.qtyInput.value) || 1;
    if (current > 1) {
      this.elements.qtyInput.value = current - 1;
    }
  }

  increaseQty() {
    const current = parseInt(this.elements.qtyInput.value) || 1;
    this.elements.qtyInput.value = current + 1;
  }

  updateFromQtyInput() {
    const qty = parseInt(this.elements.qtyInput.value) || 1;
    if (qty < 1) {
      this.elements.qtyInput.value = 1;
    }
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: this.config.currency
    }).format(amount);
  }
}

function initCalculators() {
  document.querySelectorAll('[data-calculator-root]').forEach(root => {
    new FlooringCalculator(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCalculators);
} else {
  initCalculators();
}

document.addEventListener('shopify:section:load', initCalculators);
